"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoblinGold = exports.DAO_TREASURY_OWNER = void 0;
const anchor_1 = require("@project-serum/anchor");
const addressParser_1 = require("./addressParser");
const data_1 = require("./data");
const decoder_1 = require("./decoder");
const best_apy_json_1 = __importDefault(require("./idls/best_apy.json"));
const program_1 = require("./program");
exports.DAO_TREASURY_OWNER = new anchor_1.web3.PublicKey("8XhNoDjjNoLP5Rys1pBJKGdE8acEC1HJsWGkfkMt6JP1");
class GoblinGold {
    constructor(opts) {
        this.connection = opts.connection;
        this.provider = opts.provider;
        const programId = (0, addressParser_1.addressParser)({
            group: "strategies",
            name: "bestApy",
        })["WSOL"].programId;
        if (opts.provider) {
            (0, anchor_1.setProvider)(opts.provider);
            this.BestApy = new program_1.StrategyProgram(best_apy_json_1.default, programId, opts.provider, opts.user);
        }
        else {
            this.BestApy = new program_1.StrategyProgram(best_apy_json_1.default, programId, new anchor_1.AnchorProvider(this.connection, opts.wallet, anchor_1.AnchorProvider.defaultOptions()), opts.user);
        }
    }
    getVaultsInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.strategyVaults)
                return this.strategyVaults;
            const program = this.BestApy;
            const accKeys = [];
            data_1.STRATEGY_VAULTS.forEach((sVault) => {
                const vaultKey = program.vaultKeys[sVault.input.symbol];
                accKeys.push({ accountType: "Vault", publicKey: vaultKey.vaultAccount });
                accKeys.push({
                    accountType: "Mint",
                    publicKey: vaultKey.vaultLpTokenMintAddress,
                });
            });
            const accounts = yield (0, decoder_1.decodeMultipleAccounts)(program, accKeys);
            this.strategyVaults = yield Promise.all(data_1.STRATEGY_VAULTS.map((sVault, indx) => {
                // Returned in the same order than the request
                const vault = accounts[indx * 2];
                const mint = accounts[indx * 2 + 1];
                return Object.assign(Object.assign({}, sVault), { id: sVault.lp.mintAddress, vaultAccount: program.vaultKeys[sVault.input.symbol].vaultAccount, tvl: vault.currentTvl, supply: new anchor_1.BN(mint.supply) });
            }));
            return this.strategyVaults;
        });
    }
    getVaultById(id) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getVaultsInfo();
            return (_a = this.strategyVaults) === null || _a === void 0 ? void 0 : _a.find((vault) => vault.id === id);
        });
    }
}
exports.GoblinGold = GoblinGold;
//# sourceMappingURL=client.js.map